import type { IndustryPage } from "@/lib/data";

import { plumbers } from "@/lib/industry-pages/plumbers";
import { mainContractors } from "@/lib/industry-pages/main-contractors";
import { builders } from "@/lib/industry-pages/builders";
import { electricians } from "@/lib/industry-pages/electricians";
import { roofers } from "@/lib/industry-pages/roofers";
import { homeImprovement } from "@/lib/industry-pages/home-improvement";
import { landscapers } from "@/lib/industry-pages/landscapers";
import { architects } from "@/lib/industry-pages/architects";
import { carpenters } from "@/lib/industry-pages/carpenters";
import { tradesmen } from "@/lib/industry-pages/tradesmen";
import { buildingFirms } from "@/lib/industry-pages/building-firms";
import { constructionRecruitment } from "@/lib/industry-pages/construction-recruitment";
import { productManufacturers } from "@/lib/industry-pages/product-manufacturers";
import { paintersDecorators } from "@/lib/industry-pages/painters-decorators";
import { hvac } from "@/lib/industry-pages/hvac";
import { propertyMaintenance } from "@/lib/industry-pages/property-maintenance";
import { handyman } from "@/lib/industry-pages/handyman";
import { flooring } from "@/lib/industry-pages/flooring";

/** One file per trade page so each can be edited on its own. Order = display order. */
export const industryPages: Record<string, IndustryPage> = {
  plumbers: plumbers,
  "main-contractors": mainContractors,
  builders: builders,
  electricians: electricians,
  roofers: roofers,
  "home-improvement": homeImprovement,
  landscapers: landscapers,
  architects: architects,
  carpenters: carpenters,
  tradesmen: tradesmen,
  "building-firms": buildingFirms,
  "construction-recruitment": constructionRecruitment,
  "product-manufacturers": productManufacturers,
  "painters-decorators": paintersDecorators,
  hvac: hvac,
  "property-maintenance": propertyMaintenance,
  handyman: handyman,
  flooring: flooring,
};
